// extracted by mini-css-extract-plugin
export default {"zr-heading":"Heading_zr-heading__ThRsO"};